export default "__VITE_ASSET__BoJKKpRk__"